/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-07 16:00:23
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-07 18:34:30
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/CreateButtonWithLanguageChangeWarning/index.tsx
 */
import React from 'react';
import { Button } from '@/src/components/Antd';

import { handleClick } from './tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
type Props = any & ModalProps;

type ModalProps = {
  title: string;
  content: string;
  salesChannelUuid: string;
};

function CreateButtonWithLanguageChangeWarning(props: Props) {
  const { onClick, title, content, onOkText, onCancelText, salesChannelUuid } =
    props;
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const handleOnClick = () => {
    handleClick({
      onClick,
      title,
      content,
      onOkText,
      onCancelText,
      salesChannelUuid,
      getI18n,
    });
  };

  return (
    <Button {...props} type={'primary'} onClick={handleOnClick}>
      {props.children}
    </Button>
  );
}

export default CreateButtonWithLanguageChangeWarning;
